"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RemoveAssignmentsButton_1 = require("../../../elements/RemoveAssignmentsButton");
function SignalAssignmentsColumn({ rowData, assignment, highlight, onHover, onClick, onUnlink, axis, }) {
    const diaIDs = rowData?.tableMetaInfo?.signal?.[axis]?.diaIDs || [];
    const isAssignmentActive = assignment.isActive && assignment.activated?.axis === axis;
    const tdCss = assignment.isActive || highlight.isActive
        ? {
            color: 'red',
            fontWeight: 'bold',
        }
        : {};
    return ((0, jsx_runtime_1.jsx)("td", { ...onHover, onClick: (e) => onClick(e, assignment, axis), style: { padding: '0', ...tdCss }, css: !isAssignmentActive && RemoveAssignmentsButton_1.removeAssignmentCssStyle, children: (diaIDs?.length > 0 || isAssignmentActive) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: diaIDs?.length || 0 }), (0, jsx_runtime_1.jsx)(RemoveAssignmentsButton_1.RemoveAssignmentsButton, { onClick: (e) => onUnlink(e, false, axis) })] })) }));
}
exports.default = SignalAssignmentsColumn;
